<template>
<v-content class="spinelab-website-front">
  <v-container v-if="initiated">
    <v-flex xs12 sm12 md12>
      <h1 class="text-sm-left">お問合せ管理</h1>
    </v-flex>
    <template v-if="detail">
      <v-btn
        @click="backToList()">
        一覧に戻る
      </v-btn>
      <v-layout v-for="header in allHeaders"
                :key="header.value"
                row>
        <v-flex md3>
          <v-subheader>
            <p>{{header.text}}</p>
          </v-subheader>
        </v-flex>
        <v-flex md9>
          {{editedItem[header.value]}}
        </v-flex>
      </v-layout>
      <v-btn
        @click="backToList()">
        一覧に戻る
      </v-btn>
    </template>
    <template v-else>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card class="spinelab-website-front">
          <v-flex md10 offset-md1>
            <v-card-title>
              <h3>CSVダウンロード</h3>
            </v-card-title>
            <v-card-text>
              <v-radio-group v-model="csvSelect">
                <v-radio label="このユーザのお問合せ" value="only">
                </v-radio>
              </v-radio-group>
            </v-card-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancelDialogue()">
              キャンセル
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn @click="confirmDownload()"
                   :loading="downloading"
                   color="success">
              ダウンロード
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-layout row>
        <v-btn
          @click="showUsers()">
          ユーザ管理に戻る
        </v-btn>
        <v-spacer/>
        <v-btn color="success"
               @click="showDialogue"
               :loading="downloading">
          CSVダウンロード
        </v-btn>
      </v-layout>
      <v-layout row>
        <v-spacer/>
        <v-btn icon @click="loadContacts" :disabled="loading">
          <v-progress-circular :size="20" indeterminate v-if="loading">
          </v-progress-circular>
          <v-icon v-else>cached</v-icon>
        </v-btn>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="contacts"
        :loading="loading"
        v-bind:pagination.sync="pagination"
        rows-per-page-text="一度に表示するお問合せ件数"
        :rows-per-page-items="rowsPerPageItems"
        >
        <template slot="headers" slot-scope="props">
          <th v-for="header in headers"
              :key="header.value"
              :style="`text-align: ${header.align || 'left'};`">
            {{header.text}}
          </th>
        </template>
        <template slot="items" slot-scope="props">
          <td v-for="header in headers" :key="header.value">
            <a @click="showDetail(props.item)" v-if="header.value === 'detail'">
              詳細
            </a>
            <template v-else>
              {{props.item[header.value]}}
            </template>
          </td>
        </template>
        <template slot="pageText" slot-scope="props">
          {{ props.itemsLength }}件中{{ props.pageStart }} - {{ props.pageStop }}件
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="error" icon="warning">
            '表示するお問合せが存在しません'
          </v-alert>
        </template>
      </v-data-table>
    </template>
  </v-container>
</v-content>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { saveAs } from 'file-saver';
import { convert } from 'encoding-japanese';

export default {
  name: 'AdminContacts',
  data() {
    return {
      loading: false,
      downloading: false,
      initiated: false,
      contactsData: [],
      detail: false,
      masters: [],
      editedItem: [],
      dialog: false,
      csvSelect: 'only',
      rowsPerPageItems: [50, 100, 1000],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: -1,
      },
    };
  },
  computed: {
    ...mapState({
      requests: state => state.requests,
    }),
    contacts() {
      return this.contactsData.map(
        c => ({ ...c.content_json, created_at: c.created_at, id: c.id }));
    },
    headers() {
      return this.masters
        .filter(sci => sci.m_contact_item.is_list_header)
        .map(sci => ({ text: sci.m_contact_item.key, value: sci.m_contact_item.id }))
        .concat([
          { text: '日時', value: 'created_at' },
          { text: '', value: 'detail', sortable: false },
        ]);
    },
    allHeaders() {
      return this.masters
        .map(sci => ({ text: sci.m_contact_item.key, value: sci.m_contact_item.id }))
        .concat([
          { text: '日時', value: 'created_at' },
        ]);
    },
  },
  methods: {
    ...mapActions(['showAlert', 'setSite']),
    backToList() {
      this.detail = false;
    },
    async download(data) {
      const csvHeader = this.allHeaders.map(
        header => header.text.replace('"', '""'),
      ).join(',');
      const csvContents = data.map(
        c => this.allHeaders.map(
          (header) => {
            const val = c[header.value];
            return val ? val.replace('"', '""') : '';
          }).join(','),
      ).join('\r\n');
      const csv = `${csvHeader}\r\n${csvContents}`;
      const sjisCSV = new Uint8Array(convert(csv, {
        to: 'SJIS',
        from: 'AUTO',
        type: 'array',
      }));
      const blob = new Blob([sjisCSV], { type: 'text/csv' });
      saveAs(blob, 'contacts.csv');
    },
    async showDialogue() {
      this.dialog = true;
    },
    async cancelDialogue() {
      this.dialog = false;
    },
    async confirmDownload() {
      this.downloading = true;
      switch (this.csvSelect) {
        case 'only': {
          await this.download(this.contacts);
          break;
        }
        case 'all': {
          const result = await this.requests.getAdminContacts();
          if (result) {
            await this.download(result);
          } else {
            this.showAlert({ message: undefined, type: 'error' });
          }
          break;
        }
        default: {
          this.showAlert({ message: undefined, type: 'error' });
          break;
        }
      }
      this.downloading = false;
      this.dialog = false;
    },
    async loadContacts() {
      this.loading = true;
      const sid = this.$route.params.sid;
      const result = await this.requests.getAdminContacts(sid);
      if (result) {
        this.contactsData = result;
      }
      this.loading = false;
    },
    async showUsers() {
      this.$router.push({ name: 'AdminUsers' });
    },
    async showDetail(item) {
      if (item) {
        this.editedItem = item;
        this.detail = true;
      }
    },
  },
  async created() {
    const sid = this.$route.params.sid;
    const result = await this.requests.getAdminContactMaster(sid);
    if (result) {
      this.masters = result;
    }
    await this.loadContacts();
    this.initiated = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Contacts.vue